const storages = {
  LOCAL_STORAGE: window.localStorage,
  SESSION_STORAGE: window.sessionStorage,
};

const DEFAULT_PREFIX = 'bambuser.';
const DEFAULT_STORAGE = storages.LOCAL_STORAGE;

/**
 * @param {string} key
 * @param {string} [prefix]
 * @param {string} [storage]
 */
const getItem = ({
  key,
  prefix = DEFAULT_PREFIX,
  storage = DEFAULT_STORAGE,
} = {}) => {
  try {
    return JSON.parse(storage.getItem(`${prefix}${key}`));
  } catch (e) {
    console.warn(`Could not get item with key ${prefix}${key} from ${storage}: ${e}`);
  }
};

/**
 * @param {string} key
 * @param {any} data
 * @param {string} [prefix]
 * @param {string} [storage]
 */
const setItem = ({
  key,
  data,
  prefix = DEFAULT_PREFIX,
  storage = DEFAULT_STORAGE,
} = {}) => {
  try {
    storage.setItem(`${prefix}${key}`, JSON.stringify(data));
  } catch (e) {
    console.warn(`Could not set item with key ${prefix}${key} in ${storage}: ${e}`);
  }
};

/**
 * Set or update a data object in the storage
 * @param {string} key
 * @param {object} data Data to set or update existing data with
 * @param {string} [prefix]
 * @param {string} [storage]
 */
const setOrUpdateObjectItem = ({
  key,
  data,
  prefix = DEFAULT_PREFIX,
  storage = DEFAULT_STORAGE,
} = {}) => {
  if (typeof data !== 'object') throw new Error(`Can only update items with a data object (key: ${key})`);
  const existingData = getItem({ key, prefix, storage });
  if (typeof existingData !== 'object') throw new Error(`Can not update items which are not data objects (key: ${key})`);

  setItem({
    key,
    data: {
      ...existingData,
      ...data,
    },
    prefix,
    storage,
  });
};

/**
 * @param {key} string
 * @param {string} [prefix]
 * @param {string} [storage]
 */
const removeItem = ({
  key,
  prefix = DEFAULT_PREFIX,
  storage = DEFAULT_STORAGE,
} = {}) => {
  try {
    storage.removeItem(`${prefix}${key}`);
  } catch (e) {
    console.warn(`Could not remove item with key ${prefix}${key} from ${storage}: ${e}`);
  }
};

/**
 * @param {string} [storage]
 */
const clearAll = ({
  storage = DEFAULT_STORAGE,
} = {}) => {
  try {
    storage.clear();
  } catch (e) {
    console.warn(`Could not clear storage ${storage}: ${e}`);
  }
};

const localPersistenceHelper = {
  clearAll,
  getItem,
  removeItem,
  setItem,
  setOrUpdateObjectItem,
  storages,
};

export default localPersistenceHelper;
